import deliverynotification from '../../../../pages/shipping-page/shipping-filter-bar-container/filter-options/options/delivery-notification';
import deliveryStatus from '../../../../pages/shipping-page/shipping-filter-bar-container/filter-options/options/delivery-status';
import isDomestic from '../../../../pages/shipping-page/shipping-filter-bar-container/filter-options/options/destination';
import insurance from '../../../../pages/shipping-page/shipping-filter-bar-container/filter-options/options/insurance';
import insuranceFee from '../../../../pages/shipping-page/shipping-filter-bar-container/filter-options/options/insurance-fee';
import marketplacenotification from '../../../../pages/shipping-page/shipping-filter-bar-container/filter-options/options/marketplace-notification';
import provider from '../../../../pages/shipping-page/shipping-filter-bar-container/filter-options/options/provider';
import shipmentNumber from '../../../../pages/shipping-page/shipping-filter-bar-container/filter-options/options/shipment-number';
import { AddressLine1 } from './address-line-1';
import { AddressValidationStatus } from './address-validation-status';
import { AddressLine2 } from './address-line-2';
import { AllocationStatus } from './allocation-status';
import { AmountPaid } from './amount-paid';
import { AssignedTo } from './assigned-to';
import { BuyerId } from './buyer-id';
import { BuyerName } from './buyer-name';
import { Carrier } from './carrier';
import { City } from './city';
import { Company } from './company';
import { Country } from './country';
import { CustomField1 } from './custom-field-1';
import { Customer } from './customer';
import { CustomField2 } from './custom-field-2';
import { CustomField3 } from './custom-field-3';
import { DatePaid } from './date-paid';
import { DeliverByDate } from './deliver-by-date';
import { Destination } from './destination';
import { Gift } from './gift';
import { InternalNotes } from './internal-notes';
import { ItemName } from './item-name';
import { ItemSku } from './item-sku';
import { LineItems } from './line-items';
import { Marketplace } from './marketplace';
import { NotesFromBuyer } from './notes-from-buyer';
import { NotesToBuyer } from './notes-to-buyer';
import { OrderDate } from './order-date';
import { OrderNumber } from './order-number';
import { OrderSubtotal } from './order-subtotal';
import { OrderTotal } from './order-total';
import { PackageType } from './package-type';
import { PackingSlipPrinted } from './packing-slip-printed';
import { PickingException } from './picking-exception';
import { PickListPrinted } from './pick-list-printed';
import { PaymentMethod } from './payment-method';
import { PostalCode } from './postal-code';
import { Quantity } from './quantity';
import { Rate } from './rate';
import { RecipientName } from './recipient-name';
import { RequestedServiceMapped } from './requested-service-mapped';
import { RequestedServiceMarketplace } from './requested-service-marketplace';
import { ResidentialCommercial } from './residential-commercial';
import { SellerBrand } from './seller-brand';
import { Service } from './service';
import { RateShopper } from './rate-shopper';
import { ShipByDate } from './ship-by-date';
import { ShipFrom } from './ship-from';
import { ShippingAccount } from './shipping-account/shipping-account';
import { ShippingPaid } from './shipping-paid';
import { Source } from './source';
import { State } from './state';
import { Store } from './store';
import { Tag } from './tag';
import { TaxPaid } from './tax-paid';
import { Tote } from './tote';
import { Warehouse } from './warehouse';
import { WarehouseStatus } from './warehouse-status';
import { Weight } from './weight';
import { Zone } from './zone';

// fulfillment-only imports
import shipmentnotification from '../../../../pages/shipping-page/shipping-filter-bar-container/filter-options/options/shipment-notification';
import shippingAccount from '../../../../pages/shipping-page/shipping-filter-bar-container/filter-options/options/shipping-account';

// NOTE: this array is used to filter out shipping grid options from the Orders Grid Other Options dropdown
export const shipmentGridFilters = [
  deliveryStatus,
  deliverynotification,
  insurance,
  insuranceFee,
  marketplacenotification,
  provider,
  shipmentNumber,
  shipmentnotification,
  shippingAccount,
  isDomestic,
];

/*
  The commented out options here are supported in the saved Filters contract but are not applicable to the grid, leaving them here for transparency
*/
export const savedFilterToAppliedFilterMap = {
  AddressLine1,
  AddressLine2,
  IsAllocated: AllocationStatus,
  AmountPaid,
  AssignedTo,
  BillToParty: ShippingAccount, // some interesting implementation details. shipping account can either be bill to party or a seller provider id.
  // BuyerEmail,
  BuyerName,
  BuyerId,
  CarrierId: Carrier,
  City,
  CustomerId: Customer,
  CustomField1,
  CustomField2,
  CustomField3,
  DeliverByDateTime: DeliverByDate,
  // FulfillmentPlanId,
  HasRate: Rate,
  InternalNotes,
  IsInternational: Destination,
  // ItemAttributeValue,
  IsGift: Gift,
  ItemName,
  ItemSku,
  LineItemCount: LineItems,
  MarketPlaceId: Marketplace,
  NotesToBuyer,
  NotesFromBuyer,
  OrderDateTime: OrderDate,
  // OrderGridStatus,
  OrderNumber,
  OrderSubtotal,
  OrderTotal,
  OrderWeight: Weight,
  PackageTypeId: PackageType,
  PackingSlipPrinted,
  PickBatchExceptionType: PickingException,
  PaidDateTime: DatePaid,
  PaymentMethod,
  PostalCode,
  Quantity,
  RequestedServiceMapped,
  RequestedServiceMarketPlace: RequestedServiceMarketplace,
  ResidentialIndicator: ResidentialCommercial,
  SellerBrandId: SellerBrand,
  SellerProviderId: ShippingAccount, // some interesting implementation details. shipping account can either be bill to party or a seller provider id.
  // ServiceCollection: serviceCollection,
  ShipByDateTime: ShipByDate,
  ShipFromId: ShipFrom,
  ShippingPaid,
  ShipToCompany: Company,
  ShipToCountryCode: Country,
  ShipToName: RecipientName,
  ShipToState: State,
  ShipToVerificationStatus: AddressValidationStatus,
  Source,
  StoreGuid: Store,
  Tag,
  TaxPaid,
  ToteId: Tote,
  WarehouseLocation: Warehouse,
  Zone,
};

export const orderFilterOptions = [
  AddressLine1,
  AddressLine2,
  AddressValidationStatus,
  AllocationStatus,
  AmountPaid,
  AssignedTo,
  BuyerId,
  BuyerName,
  Carrier,
  City,
  Company,
  Country,
  CustomField1,
  CustomField2,
  CustomField3,
  Customer,
  DatePaid,
  DeliverByDate,
  deliveryStatus,
  deliverynotification,
  Destination,
  Gift,
  insurance,
  insuranceFee,
  InternalNotes,
  isDomestic,
  ItemName,
  ItemSku,
  LineItems,
  Marketplace,
  marketplacenotification,
  NotesFromBuyer,
  NotesToBuyer,
  OrderDate,
  OrderNumber,
  OrderSubtotal,
  OrderTotal,
  PackageType,
  PackingSlipPrinted,
  PickingException,
  PickListPrinted,
  PaymentMethod,
  PostalCode,
  provider,
  Quantity,
  Rate,
  RateShopper,
  RecipientName,
  RequestedServiceMapped,
  RequestedServiceMarketplace,
  ResidentialCommercial,
  SellerBrand,
  Service,
  ShipByDate,
  ShipFrom,
  shipmentNumber,
  shipmentnotification,
  shippingAccount,
  ShippingAccount,
  ShippingPaid,
  Source,
  State,
  Store,
  Tag,
  TaxPaid,
  Tote,
  Warehouse,
  WarehouseStatus,
  Weight,
  Zone,
];
